<div class="p8-bdc_img-picker__img-container" fxLayout="row wrap">
  <p8-bdc-image-new></p8-bdc-image-new>
</div>
